import { Stroke, Style } from "ol/style";
import { extractTags } from "./propertyExtraction";

export function getHDLaneFunctionStyleNormal(feature) {
  return getHDLaneFunctionColorStyle(feature);
}
export function getHDLaneFunctionStyleClick(feature) {
  return getHDLaneFunctionColorStyle(feature, true, false);
}
export function getHDLaneFunctionStyleHover(feature) {
  return getHDLaneFunctionColorStyle(feature, false, true);
}

function getHDLaneFunctionColorStyle(feature, click, hover) {
  let color, width, backgroundColor, backgroundWidth;
  let lineDash = null;
  const tags = extractTags(feature);
  if (
    tags.hdMap === undefined ||
    (tags.hdMap !== "lane_center_line" && tags.hdMap !== "lane_trajectory_line")
  ) {
    return [];
  }
  backgroundColor = "white";
  if (tags.laneFunction !== undefined) {
    if (tags.laneFunction === "drivable") {
      color = "green";
    } else if (tags.laneFunction === "shoulder") {
      color = "white";
    } else {
      color = "red";
    }
    width = 2;
  } else {
    color = "green";
    width = 2;
  }
  if (
    (tags.hovLane !== undefined && tags.hovLane === "yes") ||
    (tags.hov !== undefined && tags.hov === "yes")
  ) {
    lineDash = [10, 5];
  }
  if (
    tags.vehicleRestrictionBus !== undefined ||
    tags.vehicleRestrictionHGV !== undefined ||
    (tags.vehicleRestrictionMotorVehicle !== undefined &&
      tags.vehicleRestrictionMotorVehicle !== "yes") ||
    tags.vehicleRestrictionMotorcar !== undefined ||
    tags.vehicleRestrictionPSV !== undefined ||
    tags.vehicleRestrictionTaxi !== undefined
  ) {
    backgroundColor = "orange";
    backgroundWidth = 6;
  }
  if (hover || click) {
    backgroundWidth = 8;
  }
  return [
    new Style({
      stroke: new Stroke({
        color: backgroundColor,
        width: backgroundWidth,
      }),
    }),
    new Style({
      stroke: new Stroke({
        color: color,
        width: width,
        lineDash: lineDash,
      }),
    }),
  ];
}
